




























































































































import { Vue, Component, Prop } from "vue-property-decorator";
import EditorWithFile from "@/components/EditorWithFile.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import { TestQuestionCreate as ITestQuestionCreate } from "@/api/models/test-question-create";
import { TestQuestion as ITestQuestion } from "@/api/models/test-question";
import { addQuestion } from "@/components/tests/testMethods";

@Component({ components: { CustomButton, EditorWithFile } })
export default class TestQuestionManualForm extends Vue {
  @Prop() questionProp!: ITestQuestion;
  comment: string = "";
  extendedAnswer: string = "";
  answerIndex: number = 0;
  question: ITestQuestionCreate = {
    body: "",
    answers: [
      {
        body: "",
        value: false,
        comment: ""
      },
      {
        body: "",
        value: false,
        comment: ""
      }
    ]
  };

  hideModal(id: string) {
    this.comment = "";
    this.extendedAnswer = "";
    this.$bvModal.hide(id);
  }

  showCommentModal(comment: string, index = 0) {
    this.$bvModal.show("comment-modal");
    this.comment = comment;
    this.answerIndex = index;
  }

  showExtendedAnswerModal(answer: string, index: number) {
    this.$bvModal.show("answer-modal");
    this.extendedAnswer = answer;
    this.answerIndex = index;
  }

  saveComment() {
    this.question.answers[this.answerIndex].comment = this.comment;
    this.comment = "";
    this.$bvModal.hide("comment-modal");
  }

  saveAnswer() {
    this.question.answers[this.answerIndex].body = this.extendedAnswer;
    this.extendedAnswer = "";
    this.$bvModal.hide("answer-modal");
  }

  removeAnswer(index: number) {
    if (this.question.answers.length <= 2) {
      this.$bvToast.toast(
        this.$tc(this.$translate.AQuestionCannotContainLessThanTwoAnswers),
        {
          variant: "danger",
          title: this.$tc(this.$translate.Error)
        }
      );
    } else {
      this.question.answers.splice(index, 1);
    }
  }

  addAnswer() {
    this.question.answers.push({
      body: "",
      value: false,
      comment: ""
    });
  }

  addQuestion() {
    if (!this.questionProp) {
      if (addQuestion(this.question)) {
        this.$emit("addQuestions", [this.question]);
        this.$emit("cancel");
        this.$bvToast.toast(this.$tc(this.$translate.QuestionAdded), {
          variant: "success",
          title: this.$tc(this.$translate.Successful)
        });
      }
    } else if (this.questionProp) {
      if (addQuestion(this.question)) {
        this.$emit("edit", this.question);
      }
    }
  }

  goto() {
    //@ts-ignore
    this.$refs.testFormHeader.scrollIntoView({
      block: "start",
      inline: "nearest",
      behavior: "smooth"
    });
    // window.scrollBy(0, -4);
  }

  mounted() {
    this.goto();
  }

  created() {
    if (this.questionProp) {
      this.question = this.questionProp;
    }
  }
}
